import { Chip } from '@mui/material';
import { EXPERIMENT_STATUS } from '../registryChoices';

// Same outlined-chip convention as SyncRunStatus / Crosstabs; colors per the wireframes.
const STATUS = {
  [EXPERIMENT_STATUS.DRAFT]: { label: 'Draft', color: 'default' },
  [EXPERIMENT_STATUS.VALIDATING]: { label: 'Validating', color: 'warning' },
  [EXPERIMENT_STATUS.VERIFY_COUNTS]: { label: 'Verify Counts', color: 'info' },
  [EXPERIMENT_STATUS.NEEDS_APPROVAL]: { label: 'Needs Approval', color: 'info' },
  [EXPERIMENT_STATUS.NEEDS_UPDATES]: { label: 'Needs Changes', color: 'error' },
  [EXPERIMENT_STATUS.REGISTERED]: { label: 'Registered', color: 'success' },
};

export default function RegistryStatusChip({ status }) {
  const { label, color } = STATUS[status] ?? { label: status, color: 'default' };
  return <Chip variant="outlined" size="small" color={color} label={label} sx={{ fontWeight: 600 }} />;
}
